import type { JSONContent } from '@tiptap/core';
import { fileExtension } from '../mediaViewer/mediaFileTypes';

export type DocFormat = 'markdown' | 'jdoc';

export const MARKDOWN_DOC_EXTENSIONS = new Set(['md', 'markdown']);
export const JDOC_EXTENSION = 'jdoc';

export const EMPTY_JDOC_DOC: JSONContent = {
  type: 'doc',
  content: [{ type: 'paragraph' }]
};

export const MIME_MARKDOWN = 'text/markdown; charset=utf-8';
export const MIME_JDOC = 'application/vnd.jarvis.jdoc+json; charset=utf-8';

export function isMarkdownPath(path: string): boolean {
  const ext = fileExtension(path);
  return MARKDOWN_DOC_EXTENSIONS.has(ext);
}

export function isJdocPath(path: string): boolean {
  return fileExtension(path) === JDOC_EXTENSION;
}

export function detectDocFormat(path: string): DocFormat | null {
  if (isMarkdownPath(path)) return 'markdown';
  if (isJdocPath(path)) return 'jdoc';
  return null;
}

export function contentTypeForDocFormat(format: DocFormat): string {
  return format === 'markdown' ? MIME_MARKDOWN : MIME_JDOC;
}

export function contentTypeForPath(path: string): string | null {
  const format = detectDocFormat(path);
  return format ? contentTypeForDocFormat(format) : null;
}

/** Sibling asset folder for embedded images (runbook §11). */
export function jdocAssetsFolderForPath(docPath: string): string {
  const normalized = docPath.replace(/\\/g, '/');
  const lastSlash = normalized.lastIndexOf('/');
  const parent = lastSlash >= 0 ? normalized.slice(0, lastSlash) : '';
  return parent ? `${parent}/.jdoc-assets` : '.jdoc-assets';
}
